module.exports = __webpack_public_path__ + "img/elo.15bce78c.png";